'use client'

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React from 'react'
import { useProductContext } from '@context/ProductContext/ProductContext'
import styles from './stepCards.module.scss'

const CheckBoxInputField = ({ type, index, item, children }) => {
  const { setStepCardItem } = useProductContext()

  const handleToggle = () => {
    const updatedStepCardItem = item
    setStepCardItem(updatedStepCardItem)
  }

  return (
    <label
      htmlFor={`accordion-item-${type}-${index}`}
      className={styles.checkBoxLabel}
      onClick={handleToggle}
      onMouseOver={handleToggle}>
      <input
        type="radio"
        role="button"
        name={`accordionToggle-${type}`}
        className={styles.toggleInput}
        onClick={handleToggle}
        onMouseOver={handleToggle}
        defaultChecked={index === 0}
      />
      {children}
    </label>
  )
}

export default CheckBoxInputField
